import React, { useEffect, useState } from "react";
import Select from "react-select";

// custom components
import { CustomSpinner } from "_atoms";

// tremor
import { Title, Subtitle, Flex } from "@tremor/react";

// bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

// styling
import { Colors, Spacing } from "_styles";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
  addTimelineArea,
  selectAddTimelineAreaStatus,
  selectAllTimelineAreas,
  resetAddTimelineAreaFlags,
  getTimelineAreas,
  editTimelineArea,
  selectEditTimelineAreaStatus,
  setSelectedTimeline,
  getAirportLocation,
  selectAllAirportLocations
} from "_redux/slices/timeline/timeline-areas";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectSelectedTimeline } from "_redux/slices/timeline/timeline-areas";

// constants
import { SaudiDomesticAirports, BookingTypesFilters as MainBookingTypesFilters } from "../timeline-constants";
import { selectUsedTheme } from "_redux/slices/timeline/theme";


const errorsInitState = {
  titleError: null,
  locationError: null,
};

const AddTimelineAreaForm = ({ closeModal }) => {

  const BookingTypesFilters = MainBookingTypesFilters.filter((type) => type.value !== "checkedIn");

  //#region redux states
  const dispatch = useDispatch();
  const addTimelineAreaStatus = useSelector(selectAddTimelineAreaStatus);
  const allTimelineAreas = useSelector(selectAllTimelineAreas); // select all timelineAreas
  const selectedTimeLine = useSelector(selectSelectedTimeline)
  const editTimelineAreaStatus = useSelector(selectEditTimelineAreaStatus)
  const dbUser = useSelector(selectFirebaseInfo);
  const allAirportLocations = useSelector(selectAllAirportLocations);                         // select all airport locations
  const usedTheme = useSelector(selectUsedTheme);

  //#endregion

  //#region states
  // form inputs
  const [zoneTitle, setZoneTitle] = useState(""); // holds timeline zone title
  const [zoneLocation, setZoneLocation] = useState(""); // holds timeline zone location
  const [airportType, setAirportType] = useState("international"); // holds airport type (International or domestic)
  const [flightType, setFlightType] = useState("arrivals"); // holds flight type (arrivals or departures)
  const [holdingArea, setHoldingArea] = useState(false); // holds transit area
  const [errors, setErrors] = useState(errorsInitState);
  const [jobsTypesOptions, setJobsTypesOptions] = useState([
    { label: "Arrivals", value: "arrivals" },
    { label: "Ramp", value: "ramp" },
    { label: "Departures", value: "departures" },
    { label: "Boarding", value: "boarding" },
    { label: "ALT Pick Up", value: "ALTPickUp" },
    { label: "Gate Relocation", value: "gateRelocation" },
  ]);                 // array of jobs types options(all, arrivals,....)
  const [jobsTypes, setJobsTypes] = useState([]);                 // array of jobs types to preview(all, arrivals,....)
  // const [holdingLocation, setHoldingLocation] = useState(null);         // array of holding locations in this area
  //#endregion

  //#region functions
  const handleChangeZoneTitle = (value) => {
    setZoneTitle(value);
    // check if the entered zone title already exists
    let isTitleExist = allTimelineAreas?.filter((row) => row?.title == value);
    if (isTitleExist?.length > 0) {
      setErrors((prev) => ({
        ...prev,
        titleError: "Zone title already exists!",
      }));
      return;
    }
    // reset titleError
    setErrors((prev) => ({
      ...prev,
      titleError: null,
    }));
  };

  const handleChangeZoneLocation = (value) => {
    setZoneLocation(value);
    // reset locatinError
    setErrors((prev) => ({
      ...prev,
      locationError: null,
    }));
  };

  const handleCancelButton = () => {
    closeModal();
    dispatch(setSelectedTimeline(null));
  };

  const handleConfirm = () => {
    if (!zoneTitle.length) {
      setErrors((prev) => ({
        ...prev,
        titleError: "Zone title is required!",
      }));
    }
    if (!zoneLocation.length) {
      setErrors((prev) => ({
        ...prev,
        locationError: "Zone location is required!",
      }));
    }
    let data = {
      iata: dbUser.details.authority,
      body: {
        iata: dbUser.details.authority,
        title: zoneTitle,
        location: Array.isFullArray(zoneLocation) ? zoneLocation?.map((location) => { return { locationName: location?.label, locationId: location?.value } }) : [],
        international: airportType === "both" || airportType === "international",
        domestic: airportType === "both" || airportType === "domestic",
        arrivals: flightType === "both" || flightType === "arrivals",
        departures: flightType === "both" || flightType === "departures",
        holdingArea,
        jobsType: jobsTypes,
        // holdingLocation: holdingLocation
        //   ? { locationName: holdingLocation?.label, locationId: holdingLocation?.value }
        //   : null,

      },
    };

    if (!Object.isObjectEmpty(selectedTimeLine)) {
      delete data.iata
      data["id"] = selectedTimeLine._id;
      dispatch(editTimelineArea(data))
    } else dispatch(addTimelineArea(data));
  };
  // convert the locations into array of objects {label, value } for the Select
  const transformToObject = (locationsArray) => {
    return Array.isFullArray(locationsArray)
      ? locationsArray?.map((location) => { return { label: location?.title, value: location?._id } })
      : [];
  };

  // filter the previewed booking by the type (all, departures, arrivals and ALTPikcUp)
  const changeBookingTypeFilter = (selectedValue) => {
    if (Array.isFullArray(selectedValue)) {
      setJobsTypes(selectedValue?.map((value) => value?.value));
    } else {
      if (flightType === "arrivals") {
        setJobsTypes(["arrivals"]);
      }
      if (flightType === "departures") {
        setJobsTypes(["departures"]);
      }
      if (flightType === "both") {
        setJobsTypes(["all"]);
      }
    }
  };

  const createBookingTypeFilterObj = () => {
    let appliedFilter = BookingTypesFilters.filter((type) => jobsTypes?.includes(type?.value));
    return Array.isFullArray(appliedFilter) ? appliedFilter : []
  };

  const handleFlightTypeSwitch = (value) => {
    setFlightType(value);
    if (value === "arrivals") {
      setJobsTypesOptions([
        { label: "Arrivals", value: "arrivals" },
        { label: "Ramp", value: "ramp" },
      ]);
      setJobsTypes(["arrivals", "ramp"]);
    }
    if (value === "departures") {
      setJobsTypesOptions([
        { label: "Departures", value: "departures" },
        { label: "Boarding", value: "boarding" },
        { label: "ALT Pick Up", value: "ALTPickUp" },
        { label: "Gate Relocation", value: "gateRelocation" },
      ]);
      setJobsTypes(["departures", "boarding", "ALTPickUp", "gateRelocation"]);
    }
    if (value === "both") {
      setJobsTypesOptions(BookingTypesFilters);
      setJobsTypes(["all"]);
    }
  }

  useEffect(() => {
    console.log("jobsTypes", jobsTypes);
  }, [jobsTypes])
  //#endregion

  //#region useEffects
  useEffect(() => {
    setErrors(errorsInitState);
    dispatch(resetAddTimelineAreaFlags());
    dispatch(getAirportLocation(dbUser.details.authority));
  }, []);


  useEffect(() => {

    if (addTimelineAreaStatus === "succeeded" || editTimelineAreaStatus === "succeeded") {
      dispatch(getTimelineAreas(dbUser.details.authority));
      dispatch(getAirportLocation(dbUser.details.authority));

      closeModal();
      setErrors(errorsInitState);
      dispatch(resetAddTimelineAreaFlags());
      dispatch(setSelectedTimeline(null));
    }
  }, [addTimelineAreaStatus, editTimelineAreaStatus]);

  useEffect(() => {
    if (!Object.isObjectEmpty(selectedTimeLine)) {
      let tempLocation = Array.isFullArray(selectedTimeLine.location)
        ? selectedTimeLine.location?.map((location) => { return { label: location?.locationName, value: location?.locationId } })
        : [];
      setZoneTitle(selectedTimeLine.title)
      setZoneLocation(tempLocation)
      setAirportType(selectedTimeLine.international && selectedTimeLine.domestic ? "both" : selectedTimeLine.international ? "international" : "domestic")
      setFlightType(selectedTimeLine.arrivals && selectedTimeLine.departures ? "both" : selectedTimeLine.arrivals ? "arrivals" : "departures")
      setHoldingArea(selectedTimeLine.holdingArea)
      // setHoldingLocation(selectedTimeLine?.holdingLocation ? { label: selectedTimeLine?.holdingLocation?.locationName, value: selectedTimeLine?.holdingLocation?.locationId } : null)
      if (Array.isFullArray(selectedTimeLine.jobsType)) setJobsTypes(selectedTimeLine.jobsType);
      if (selectedTimeLine.arrivals && selectedTimeLine.departures) {
        setJobsTypesOptions(BookingTypesFilters);

      } else if (selectedTimeLine.arrivals) {
        setJobsTypesOptions([
          { label: "Arrivals", value: "arrivals" },
          { label: "Ramp", value: "ramp" },
        ]);
      } else if (selectedTimeLine.departures) {
        setJobsTypesOptions([
          { label: "Departures", value: "departures" },
          { label: "Boarding", value: "boarding" },
          { label: "ALT Pick Up", value: "ALTPickUp" },
        ]);
      }
    }
  }, [selectedTimeLine]);

  //#endregion
  return (
    <div style={{ padding: Spacing.SCALE_12, opacity: addTimelineAreaStatus === "loading" ? 0.3 : 1.0, marginBottom:100 }}>
      <div>

        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>
          <p style={{ margin: 0, padding: 0, height: "24px" }}>
            Airport Area Title
          </p>
          <p style={{ color: "red", margin: 0, padding: 0, height: "24px" }}>
            *
          </p>
        </Form.Label>
        <Form.Control
          onChange={(e) => handleChangeZoneTitle(e.target.value)}
          style={{ borderColor: errors?.titleError && errors?.titleError?.length > 0 ? "red" : null }}
          type="name"
          placeholder="Enter zone title"
          value={zoneTitle}
        />
        {errors?.titleError && (
          <div style={{ color: "red" }}>{errors?.titleError}</div>
        )}

        {/* location list */}
        <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Locations List</Form.Label>
        <Subtitle>Add the locations in your airport that are within this area</Subtitle>

        <div className='mt-2'>
          <Select isMulti options={transformToObject(allAirportLocations)} className="basic-multi-select" classNamePrefix="select" onChange={(selection) => { setZoneLocation(selection) }} value={zoneLocation} />
        </div>

        {/* Flight Type */}
        {SaudiDomesticAirports.includes(dbUser.details.authority) &&
          <>
            <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Flight Type</Form.Label>
            <Subtitle>Select the type of passenger that is assisted in this airport area</Subtitle>

            <Flex>
              <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="International" value="international" checked={airportType === "international"} onChange={(e) => setAirportType(e.target.value)} />
              <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="Domestic" value="domestic" checked={airportType === "domestic"} onChange={(e) => setAirportType(e.target.value)} />
              <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="Both" value="both" checked={airportType === "both"} onChange={(e) => setAirportType(e.target.value)} />
            </Flex>
          </>
        }

        {/* passenger type */}
        <div className='mt-3'>
          <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Passenger Type</Form.Label>

          <Flex>
            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="Arrivals" value="arrivals" checked={flightType === "arrivals"} onChange={(e) => handleFlightTypeSwitch(e.target.value)} />
            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="Departures" value="departures" checked={flightType === "departures"} onChange={(e) => handleFlightTypeSwitch(e.target.value)} />
            <Form.Check className='d-flex gap-2 align-items-center' type="radio" label="Both" value="both" checked={flightType === "both"} onChange={(e) => handleFlightTypeSwitch(e.target.value)} />
          </Flex>

        </div>

        {/* jobs type */}
        <div className='mt-3'>
          <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Jobs Type</Form.Label>
          <Subtitle>Select the type of jobs that are assisted in this airport area (departures, boarding, arrivals, etc.)</Subtitle>

          <Select
            options={jobsTypesOptions}
            placeholder="Displayed bookings..."
            onChange={(selection) => changeBookingTypeFilter(selection)}
            value={createBookingTypeFilterObj()}
            // isDisabled={selectedTimeline?.arrivals === true && selectedTimeline?.departures !== true}
            isMulti={true}
            styles={{
              control: (provided) => ({
                ...provided,
                backgroundColor: usedTheme.BACKGROUND_COLOR,
                borderColor: usedTheme.BORDER_COLOR,
                color: usedTheme.TEXT_COLOR,
                minHeight: '38px',
                marginTop: Spacing.SCALE_8,
              }),
              placeholder: (provided) => ({
                ...provided,
                color: usedTheme.TEXT_COLOR,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: usedTheme.TEXT_COLOR,
              }),
              multiValue: (provided) => ({
                ...provided,
                backgroundColor: usedTheme.BORDER_COLOR,
              }),
              multiValueLabel: (provided) => ({
                ...provided,
                color: usedTheme.TEXT_COLOR,
              }),
              multiValueRemove: (provided) => ({
                ...provided,
                color: usedTheme.TEXT_COLOR,
                ':hover': {
                  backgroundColor: usedTheme.BORDER_COLOR,
                  color: usedTheme.TEXT_COLOR,
                },
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 4,
                backgroundColor: usedTheme.BACKGROUND_COLOR,
                borderColor: usedTheme.BORDER_COLOR,
                color: usedTheme.TEXT_COLOR
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused
                  ? usedTheme.BORDER_COLOR
                  : usedTheme.BACKGROUND_COLOR,
                color: usedTheme.TEXT_COLOR,
                cursor: 'pointer',
              }),
            }}
          />
        </div>

        {flightType === "arrivals" && (
          <div className='mt-3'>
            <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Holding Area</Form.Label>
            <Subtitle>Select if this area is a holding area for the arrivals</Subtitle>
            <Flex>
              <Form.Check
                type="checkbox"
                checked={holdingArea}
                onChange={() => {
                  setHoldingArea(!holdingArea);
                  // setHoldingLocation(null)
                }} />
            </Flex>
            {/* {holdingArea && (
              <div className='mt-3'>
                <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE, display: "flex" }}>Holding Location</Form.Label>
                <Subtitle>Select the holding location in this area</Subtitle>
                <Select
                  options={transformToObject(allAirportLocations)}
                  placeholder="Holding location..."
                  onChange={(selection) => setHoldingLocation(selection)}
                  value={holdingLocation}
                  isMulti={false}
                  clearable={true}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: usedTheme.BACKGROUND_COLOR,
                      borderColor: usedTheme.BORDER_COLOR,
                      color: usedTheme.TEXT_COLOR,
                      minHeight: '38px',
                      marginTop: Spacing.SCALE_8,
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: usedTheme.TEXT_COLOR,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: usedTheme.TEXT_COLOR,
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      backgroundColor: usedTheme.BORDER_COLOR,
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      color: usedTheme.TEXT_COLOR,
                    }),
                    multiValueRemove: (provided) => ({
                      ...provided,
                      color: usedTheme.TEXT_COLOR,
                      ':hover': {
                        backgroundColor: usedTheme.BORDER_COLOR,
                        color: usedTheme.TEXT_COLOR,
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 4,
                      backgroundColor: usedTheme.BACKGROUND_COLOR,
                      borderColor: usedTheme.BORDER_COLOR,
                      color: usedTheme.TEXT_COLOR
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? usedTheme.BORDER_COLOR
                        : usedTheme.BACKGROUND_COLOR,
                      color: usedTheme.TEXT_COLOR,
                      cursor: 'pointer',
                    }),
                  }}
                />
              </div>
            )} */}
          </div>
        )}

        {/* buttons */}
        <div style={{ marginTop: Spacing.SCALE_22 }}>
          <Flex>
            <Button variant="danger" onClick={handleCancelButton}>{"Cancel"}</Button>
            <Button onClick={handleConfirm} variant={"primary"} style={{ marginLeft: Spacing.SCALE_8 }} disabled={zoneTitle.length ? false : true}>{addTimelineAreaStatus == "loading" || editTimelineAreaStatus == "loading" ? (<CustomSpinner />) : ("Confirm")}</Button>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default AddTimelineAreaForm;
